/* Button.tsx
   Version: 1.2.1
   Date: 2021-03-26
*/

// eslint-disable-next-line
import React from 'react';
import PropTypes from 'prop-types';

export interface ButtonProps {
    className?: string
    name: string;
    value: string;
    index?: number;
    disabled?: boolean;
    title?: string;
    refFunc?: (input: HTMLInputElement) => void;
    onClick: (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => void;
}

const Button: React.FC<ButtonProps> = (props): JSX.Element => {

    Button.propTypes = {
        className: PropTypes.string,
        name: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
        index: PropTypes.number,
        disabled: PropTypes.bool,
        title: PropTypes.string,
        refFunc: PropTypes.func,
        onClick: PropTypes.func.isRequired,
    }

    return <input 
        type='button' 
        className={props.className ?? 'basic-button'} 
        data-name={props.name}
        data-index={props.index}
        value={props.value}
        disabled={props.disabled}
        title={props.title}
        ref={props.refFunc}
        onClick={props.onClick} 
        />

}

export default Button;
